import PropTypes from 'prop-types'
import { useTheme } from '@emotion/react'
import { List, ListItem } from 'chaoskit/src/components'
import { link } from 'chaoskit/src/assets/styles/utility'

import { StylesHeaderVariables } from '~partials/header/UI'
import { stickyIt } from '~styles/utility'

const TableOfContents = ({ tree, ...rest }) => {
  const theme = useTheme()

  return (
    <aside
      css={{
        ...stickyIt(theme),
        overflow: 'auto',
        maxHeight: `calc(var(--rh) - ${
          StylesHeaderVariables(theme).height + theme.space.base
        }px)`,
        scrollbarWidth: 'none',
        MsOverflowStyle: 'none',
        WebkitOverflowScrolling: 'touch',

        '::-webkit-scrollbar': {
          width: 0,
        },
      }}
      {...rest}
    >
      <List
        space="small"
        css={{
          fontSize: theme.fontSize.small,

          a: [
            link.muted(theme),
            {
              fontWeight: theme.fontWeight.medium,
            },
          ],
        }}
      >
        {tree.items.map((branch) => (
          <ListItem key={branch.url}>
            <div>
              <a href={branch.url}>{branch.title}</a>
            </div>
            {branch.items && (
              <List
                space="xsmall"
                css={{
                  marginTop: `${theme.space.small}px !important`,
                  fontSize: theme.fontSize.xsmall,

                  a: {
                    fontWeight: theme.fontWeight.base,
                  },
                }}
              >
                {branch.items.map((twig) => (
                  <ListItem key={twig.url}>
                    <div>
                      <a href={twig.url}>{twig.title}</a>
                    </div>
                  </ListItem>
                ))}
              </List>
            )}
          </ListItem>
        ))}
      </List>
    </aside>
  )
}

TableOfContents.propTypes = {
  tree: PropTypes.object.isRequired,
}

export default TableOfContents
